import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './PriorInsuranceHistoryComponent.metadata.json5';
import styles from '../MedicalPractitioners.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function PriorInsuranceHistoryComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PriorInsuranceHistoryComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesExp3: {
            visible: !_.isUndefined(modelVM.value.hasTheAppEveHadInsRef2) && modelVM.value.hasTheAppEveHadInsRef2
        },
        ifYesPleDes6: {
            visible: !_.isUndefined(modelVM.value.isTheAppComParDirOr5) && modelVM.value.isTheAppComParDirOr5
        },
        ifYesPleDes8: {
            visible: !_.isUndefined(modelVM.value.isTheAppComItsParDir7) && modelVM.value.isTheAppComItsParDir7
        },
        ifYesPleDesInDet10: {
            visible: !_.isUndefined(modelVM.value.isTheAppComParDirOff9) && modelVM.value.isTheAppComParDirOff9
        },
        ifYesPleDes12: {
            visible: !_.isUndefined(modelVM.value.hasTheAppComEveBroA11) && modelVM.value.hasTheAppComEveBroA11
        },
        doYouOrAnyLivUndYou13: {
            visible: _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC'
        },
        ifYesPleDes15: {
            visible: !_.isUndefined(modelVM.value.hasTheAppComParDirOff14) && modelVM.value.hasTheAppComParDirOff14
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PriorInsuranceHistoryComponent.propTypes = wizardProps;
export default withRouter(PriorInsuranceHistoryComponent);
